<template>
  <section class="business-matrix">
    <div class="business-matrix__body">
      <div class="business-matrix__lead">
        <div class="business-matrix__top">
          <span class="business-matrix__label">{{ data.label }}</span>
          <h2 class="business-matrix__title">{{ data.title }}</h2>
        </div>
        <p class="business-matrix__desc">{{ data.description }}</p>
      </div>
      <div
        v-for="(card, index) in data.cards"
        :key="index"
        class="business-matrix__card"
        :class="{ 'business-matrix__card--alt': index % 2 === 1 }"
        @click="$emit('navigate', card.route)"
      >
        <div class="business-matrix__card-img">
          <img :src="card.image" :alt="card.title" />
        </div>
        <div class="business-matrix__card-content">
          <h3 class="business-matrix__card-title">{{ card.title }}</h3>
          <p class="business-matrix__card-copy">{{ card.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BusinessMatrix",
  props: {
    data: {
      type: Object,
      default: () => ({
        label: "",
        title: "",
        description: "",
        cards: [],
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.business-matrix {
  padding: 40px 40px;
  background-color: #194670;
  box-sizing: border-box;

  &__body {
    display: flex;
    gap: 22px;
  }

  &__lead {
    width: 430px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__top {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__label {
    font-family: $font-family;
    font-size: $font-size-label;
    font-weight: normal;
    letter-spacing: 1.5px;
    color: #d8c08e;
    text-align: left;
  }

  &__title {
    font-family: $font-family;
    font-size: 60px;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    text-align: left;
  }

  &__desc {
    font-family: $font-family;
    font-size: $font-size-body;
    font-weight: normal;
    line-height: 1.74;
    color: #ffffffb8;
    margin: 0;
    text-align: left;
  }

  &__card {
    flex: 1;
    border-radius: 16px;
    background: #f6f2ea;
    padding: 22px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;

    &--alt {
      background: #d7e3ef;
    }
  }

  &__card-img {
    border-radius: 12px;
    height: 224px;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        145deg,
        rgba(16, 42, 67, 0.22),
        rgba(214, 184, 122, 0.22)
      );
    }
  }

  &__card-content {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  &__card-title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: left;
  }

  &__card-copy {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.72;
    color: #5e574d;
    text-align: left;
    margin: 0;
  }

  @include tablet {
    padding: 40px 32px;

    &__body {
      flex-direction: column;
    }

    &__lead {
      width: 100%;
    }

    &__title {
      font-size: 42px;
    }
  }

  @include mobile {
    padding: 32px 20px;

    &__body {
      flex-direction: column;
    }

    &__lead {
      width: 100%;
    }

    &__title {
      font-size: 30px;
    }

    &__card-img {
      height: 180px;
    }
  }
}
</style>
